<template>
    <section class="bg-darker pt-5">
        <div class="container">
            <div class="row">
                <div class="col-sm-4">
                    <hostel-search></hostel-search>
                </div>
                <div class="col-sm-8">
                    <hostel-lists></hostel-lists>
                </div>
            </div>
        </div>

    </section>
</template>
<script>
import HostelSearch from "./HostelSearch";
import HostelLists from "./HostelLists";

export default {
  name: "hostel-view",
  components: {
    HostelSearch,
    HostelLists
  }
};
</script>
